module.exports = __webpack_public_path__ + "static/media/1-1-mobile.738d5430.webp";